import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-change-language-consequence',
  templateUrl: './change-language-consequence.component.html',
  styleUrls: ['./change-language-consequence.component.scss'],
})
export class ChangeLanguageConsequenceComponent {
  @Input() changeLanguage: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  initConsequenceObject(): void {
    console.log(this.changeLanguage);
    var tmpObj = {
      class:
        'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Consequences$ChangeLanguage',
    };
    if (this.changeLanguage) {
      this.changeLanguage.push(tmpObj);
    } else {
      this.changeLanguage = [];
      this.changeLanguage.push(tmpObj);
    }
    console.log(this.changeLanguage);
  }

  updateConsequences() {
    this.debouncer.next(this.changeLanguage);
  }

  removeConsequence(consequence) {
    this.changeLanguage.splice(this.changeLanguage.indexOf(consequence), 1);
    this.updateConsequences();
  }
}
